import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const CarouselWrapper = styled.div`
  margin: 0 0 0 60px;
  height: 400px;
  background: #bdbdbd;

  .slick-dots {
    bottom: 90px;

    li {
      margin: 0 10px;
    }

    li button::before {
      font-size: 18px;
      opacity: 0.7;
      color: white;

      ${mediaMaxWidth.tablet} {
        font-size: 15px;
      }
    }

    li.slick-active button::before {
      font-size: 18px;
      opacity: 1;
      color: #79D9D9;

      ${mediaMaxWidth.tablet} {
        font-size: 15px;
      }
    }

    ${mediaMaxWidth.tablet} {
      bottom: 60px;
    }
  }

  ${mediaMinWidth.tablet} {
    margin: 0 auto 0 auto;
    width: 700px;
    position: relative;
    z-index: 0;
    top: 10px;

    .slick-track {
      background: #e4e4e4;
    }

    img {
      border-radius: 8px;
    }
  }

  ${mediaMinWidth.smallDesktop} {
    width: 900px;
  }

  ${mediaMinWidth.desktop} {
    width: 1100px;
    height: 500px;
  }

  ${mediaMaxWidth.tablet} {
    margin-left: 0;
  }

  ${mediaMaxWidth.phone} {
    height: 200px;
  }
`;

export const CarouselSlide = styled.div`
  height: 400px;

  ${mediaMinWidth.desktop} {
    height: 500px;
  }

  ${mediaMaxWidth.phone} {
    height: 200px;
  }
`;

export const CarouselVideo = styled.video`
  height: 100%;
  min-width: 100%;
  object-fit: cover;
`;

export const CarouselImage = styled.img`
  height: 100%;
  min-width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  z-index: -1;
`;
